<script>
  import {Input, InputGroup, Container, Row, Col, InputGroupText, Button} from "sveltestrap";
  import List from '../crud/list.svelte';
  import CellRef from '../crud/cell-types/cell-ref.svelte';
  import CellDate from '../crud/cell-types/cell-date.svelte';
  import {createRecord} from "../../modules/api-client";

  const DAY = 3600 * 1000 * 24;

  function pickerDateFormat(date) {
    return date.toISOString().slice(0, -14);
  }

  const urlParams = new URLSearchParams(window.location.search);

  const now = new Date();
  const year = now.getFullYear();
  const month = new Date().getMonth();
  const day = new Date().getDate();
  let filterMonth = urlParams.has('month') ? urlParams.get('month') : month + 1;
  const newTime = {
    start: new Date(year, month, day, 10, 0).toISOString(),
    end: new Date(year, month, day, 11, 0).toISOString(),
    worker: {_id: "622b2a26e68b8910f3243c58", name: "Xavi"},
    project: {_id: "622b35d01b3a920b69ec42a4", name: "Flamed"},
  }

  function addOneHour(time) {
    console.log('adding')
    const newTime = new Date(Date.parse(time));
    newTime.setHours(newTime.getHours() + 1);
    return newTime;
  }

  let startTime = newTime.start;

  function startUpdated() {
    newTime.start = startTime;
    newTime.end = addOneHour(newTime.start);
  }
  $: startTime, startUpdated()

  const query = {
    start: {
      $gte: new Date(now.getFullYear(), filterMonth - 2, 21).toISOString(),
      $lt: new Date(now.getFullYear(), filterMonth - 1, 21).toISOString()
    }
  };

  function goToDate() {
    location.replace(`?month=${filterMonth}`);
  }

  function add() {
    createRecord('times', newTime);
    location.reload();
  }

</script>

<div class="container-fluid">
    <div class="card shadow mb-4">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary title">Tracking times</h6>
        </div>
        <div class="card-body">
            <table>
                <tr>
                    <td class="month">
                        <InputGroup>
                            <InputGroupText>Month</InputGroupText>
                            <Input type="number" bind:value="{filterMonth}" on:change={goToDate}/>
                        </InputGroup>
                    </td>
                    <td>
                        <InputGroup>
                            <InputGroupText>Start</InputGroupText>
                            <CellDate bind:value="{startTime}"/>
                        </InputGroup>
                    </td>
                    <td>
                        <InputGroup>
                            <InputGroupText>End</InputGroupText>
                            <CellDate bind:value="{newTime.end}"/>
                        </InputGroup>
                    </td>
                    <td>
                        <InputGroup>
                            <InputGroupText>Worker</InputGroupText>
                            <CellRef ref="workers" bind:value={newTime.worker}/>
                        </InputGroup>
                    </td>
                    <td>
                        <InputGroup>
                            <InputGroupText>Project</InputGroupText>
                            <CellRef ref="projects" bind:value={newTime.project}/>
                        </InputGroup>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Button on:click={add}>Add</Button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
<List table="times" filter="{query}" sort="{{start: -1}}" disable="create"/>

<style>
    table {
        width: 100%
    }

    .month {
        width: 12%;
    }
</style>
